import { useTranslation } from 'react-i18next';
import { Clock, XCircle } from 'lucide-react';

import { AuthLayout } from '@/layouts/AuthLayout';
import { AuthFormShell } from '@/components/PageHeader';
import { Loading } from '@/components/Loading';
import { useAuth } from '@/lib/auth';
import {
  userRegistrationPending,
  userRegistrationRejected,
} from '@/lib/registrationApproval';

export default function WaitingListPage() {
  const { t } = useTranslation();
  const { user, isLoading } = useAuth({
    middleware: 'auth',
    redirectTo: '/auth/login',
    tmp: 'WaitingListPage',
  });

  if (isLoading || !user) {
    return <Loading />;
  }

  const rejected = userRegistrationRejected(user);
  const pending = userRegistrationPending(user);

  return (
    <AuthLayout hideFooter>
      <title>
        {rejected ? t('waitingList.rejected.title') : t('waitingList.pending.title')}
      </title>

      <AuthFormShell
        title={rejected ? t('waitingList.rejected.title') : t('waitingList.pending.title')}
        description={
          rejected
            ? t('waitingList.rejected.description')
            : pending
              ? t('waitingList.pending.description')
              : t('waitingList.pending.description')
        }
      >
        <div className="flex justify-center pb-4">
          {rejected ? (
            <XCircle className="size-16 text-destructive" />
          ) : (
            <Clock className="size-16 text-brand-primary" />
          )}
        </div>
      </AuthFormShell>
    </AuthLayout>
  );
}
